import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './customer-order.reducer';

export const CustomerOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const customerOrderEntity = useAppSelector(state => state.customerOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="customerOrderDetailsHeading">
          <Translate contentKey="crawlerBackendApp.customerOrder.detail.title">CustomerOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.id}</dd>
          <dt>
            <span id="orderDate">
              <Translate contentKey="crawlerBackendApp.customerOrder.orderDate">Order Date</Translate>
            </span>
          </dt>
          <dd>
            {customerOrderEntity.orderDate ? (
              <TextFormat value={customerOrderEntity.orderDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="desiredDate">
              <Translate contentKey="crawlerBackendApp.customerOrder.desiredDate">Desired Date</Translate>
            </span>
          </dt>
          <dd>
            {customerOrderEntity.desiredDate ? (
              <TextFormat value={customerOrderEntity.desiredDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="crawlerBackendApp.customerOrder.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.orderStatus}</dd>
          <dt>
            <span id="initialFixedAnnualPrice">
              <Translate contentKey="crawlerBackendApp.customerOrder.initialFixedAnnualPrice">
                Initial Fixed Annual Price
              </Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.initialFixedAnnualPrice}</dd>
          <dt>
            <span id="initialFixedMonthlyPrice">
              <Translate contentKey="crawlerBackendApp.customerOrder.initialFixedMonthlyPrice">
                Initial Fixed Monthly Price
              </Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.initialFixedMonthlyPrice}</dd>
          <dt>
            <span id="contractType">
              <Translate contentKey="crawlerBackendApp.customerOrder.contractType">Contract Type</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.contractType}</dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.customerOrder.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {customerOrderEntity.createdTimestamp ? (
              <TextFormat value={customerOrderEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="depositRequired">
              <Translate contentKey="crawlerBackendApp.customerOrder.depositRequired">Deposit Required</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.depositRequired ? 'true' : 'false'}</dd>
          <dt>
            <span id="deposit">
              <Translate contentKey="crawlerBackendApp.customerOrder.deposit">Deposit</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.deposit ? 'true' : 'false'}</dd>
          <dt>
            <span id="offerFilePath">
              <Translate contentKey="crawlerBackendApp.customerOrder.offerFilePath">Offer File Path</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.offerFilePath}</dd>
          <dt>
            <span id="contractFilePath">
              <Translate contentKey="crawlerBackendApp.customerOrder.contractFilePath">Contract File Path</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.contractFilePath}</dd>
          <dt>
            <span id="checkSendEmail">
              <Translate contentKey="crawlerBackendApp.customerOrder.checkSendEmail">Check Send Email</Translate>
            </span>
          </dt>
          <dd>{customerOrderEntity.checkSendEmail}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customerOrder.customer">Customer</Translate>
          </dt>
          <dd>{customerOrderEntity.customer ? customerOrderEntity.customer.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customerOrder.supplier">Supplier</Translate>
          </dt>
          <dd>{customerOrderEntity.supplier ? customerOrderEntity.supplier.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/customer-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/customer-order/${customerOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CustomerOrderDetail;
